<template>
  <div>
    <div class="jumbotron">
      <div class="btn-group pull-right" role="group" aria-label="">
        <button type="button" class="btn btn-sm btn-primary" @click="clickCreateNew" v-if="!loading">
          <i class="fas fa-plus-circle"></i> Create new
        </button>
      </div>

      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item"><a href="#/sync">Sync</a></li>
        <li class="breadcrumb-item active" v-if="!$route.params.name">Dashboards</li>
        <li class="breadcrumb-item" v-if="$route.params.name"><a href="#/sync-dashboard">Dashboards</a></li>
        <li class="breadcrumb-item active" v-if="$route.params.name">{{$route.params.name}}</li>
      </ol>

      <div class="row">
        <div class="col-md-4">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>View dashboard</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-info-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-warning text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Update dashboard</p>
              </blockquote>
              <i aria-hidden="true" class="fa fa-wrench card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-danger text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Remove dashboard</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-minus-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-good-table
        v-if="!$route.params.name"
        title="Sync Dashboards"
        :lineNumbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'name', type: 'asc'}
        }"
        :select-options="{ enabled: false }"
        :search-options="{ enabled: true }"
        styleClass="vgt-table striped bordered table-hover"
        :columns="columns"
        :rows="rows"
        :paginationOptions="{
          enabled: true
        }">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'name'">
              {{props.row.name}}
          </span>
          <span v-if="props.column.field == 'actions'">
            <div class="btn-group text-right" role="group">
              <button type="button" class="btn btn-primary btn-sm" @click="viewBtnClick(props.row)">
                <i class="fas fa-info-circle"></i> View
              </button>
              <button type="button" class="btn btn-warning btn-sm" @click="updateBtnClick(props.row)">
                <i aria-hidden="true" class="fa fa-wrench"></i> Update
              </button>
              <button type="button" class="btn btn-danger btn-sm" @click="deleteBtnClick(props.row)">
                <i class="fas fa-minus-circle"></i> Delete
              </button>
            </div>
          </span>
        </template>
    </vue-good-table>
    <loading :active.sync="loading"></loading>
    <modal :show.sync="modalShow" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{modalTitle}}</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="form-group">
          <label class="col-form-label">Dashboard Name</label>
          <input v-model="modalDashboardNameInput" class="form-control" type="text" v-bind:readonly="modalIsEditMode">
          <small class="form-text text-muted">The name of this dashboard.</small>
        </div>
        <vue-good-table
            :columns="columns2"
            :rows="rows2"
            :lineNumbers="true"
            :sort-options="{
              enabled: true,
              initialSortBy: {field: 'appName', type: 'asc'}
            }"
            :select-options="{ enabled: true }"
            styleClass="vgt-table striped bordered table-hover"
            @on-select-all="onSelectAll"
            @on-row-click="onRowClick"
            :paginationOptions="{
              enabled: true,
              perPage: 5
            }"
            :searchOptions="{
              enabled: false
            }">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'appName'">
                {{props.row.appName}}
              </span>
              <span v-if="props.column.field == 'id'">
                {{props.row.id}}
              </span>
            </template>
        </vue-good-table>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-secondary" v-on:click="closeModalBtnClick">Close</button>
        <button type="button" class="btn btn-warning" v-on:click="repickAppsModalBtnClick" v-if="!$route.params.name">Repick Apps</button>
        <button type="button" class="btn btn-primary" v-on:click="saveModalBtnClick">Save</button>
      </div>
    </modal>
    <modal :show.sync="modalDeleteShow" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{modalTitle}}</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="form-group">
          Are you sure you want to delete this dashboard ?
        </div>
        <div class="form-group">
            <div class="input-group">
              <label class="col-4 col-form-label text-danger">Enter DELETE in capital letters</label>
              <input v-model="modalDeleteConfirmInput" class="form-control" type="text">
            </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" v-on:click="closeModalBtnClick">Close</button>
        <button type="button" class="btn btn-primary" @click="confirmDeleteModalBtnClick" :disabled="deleteDisabled">Delete</button>
      </div>
    </modal>
    <vue-good-table
        v-if="$route.params.name"
        :columns="columns3"
        :rows="rows2"
        :lineNumbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'appName', type: 'asc'}
        }"
        :select-options="{ enabled: false }"
        styleClass="vgt-table striped bordered table-hover"
        :paginationOptions="{
          enabled: false
        }"
        :searchOptions="{
          enabled: false
        }">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'status'">
            <div v-if="props.row.status === 'Enabled'">
              <span class="badge badge-success">
                <i class="fa fa-play" aria-hidden="true"></i>
                {{props.row.status}}
              </span>
            </div>
            <div v-if="props.row.status === 'Disabled'">
              <span class="badge badge-warning">
                <i class="fa fa-stop" aria-hidden="true"></i>
                {{props.row.status}}
              </span>
            </div>
            <div v-if="props.row.status === 'Halted'">
              <span class="badge badge-danger">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                {{props.row.status}}
              </span>
            </div>
          </span>
          <span v-if="props.column.field == 'appName'">
              {{props.row.appName}}
          </span>
          <span v-if="props.column.field == 'id'">
            {{ props.row.id }}
          </span>
          <span v-if="props.column.field == 'heliumBaseUrl'">
          {{ props.row.heliumBaseUrl }}
          </span>
          <span v-if="props.column.field == 'journeyBaseUrl'">
            {{ props.row.journeyBaseUrl }}
          </span>
          <span v-if="props.column.field == 'heliumLastUpdated'">
            {{ formatMillis(props.row.heliumLastUpdated) }}
          </span>
          <span v-if="props.column.field == 'journeyLastUpdated'">
            {{ formatMillis(props.row.journeyLastUpdated) }}
          </span>
          <span v-if="props.column.field == 'lastPinged'">
            {{ formatMillis(props.row.lastPinged) }}
          </span>
        </template>
    </vue-good-table>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.min.css'
  import { modal } from 'vue-strap'
  import DatetimeStringFactory from '@/components/DatetimeStringFactory.js'
  export default {
    components: {
      Loading,
      modal
    },
    data () {
      return {
        syncDashboardUrl: this.$parent.baseUrl + '/portal-backend/api/sync-dashboard/',
        rows: [],
        rows2: [],
        rows3: [],
        loading: false,
        modalShow: false,
        modalDeleteShow: false,
        modalBackdrop: false,
        modalTitle: '',
        modalDeleteConfirmInput: '',
        deleteDisabled: true,
        dashboardToBeDeleted: null,
        modalMergeShow: false,
        modalDashboardNameInput: '',
        modalDashboardAppIds: [],
        timer: ''
      }
    },
    methods: {
      getSyncDashboards: function () {
        let vm = this
        vm.loading = true
        vm.axios.get(vm.syncDashboardUrl + 'null')
          .then(function (response) {
            vm.rows = response.data
            vm.loading = false
          })
          .catch(function (error) {
            console.log(error)
            vm.loading = false
            let obj = {
              title: 'Problem looking up dashboards',
              message: error.response,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      getSyncDashboardResults: function (name) {
        let vm = this
        let endpoint = vm.syncDashboardUrl + name
        vm.loading = true
        vm.axios.get(endpoint)
          .then(function (response) {
            if (!vm.$route.params.name) {
              vm.modalShow = true
            }
            vm.rows2 = response.data
            var selectAll = {}
            vm.rows2.forEach(function () {
              if (name === 'all-apps') {
                selectAll['selected'] = false
              } else {
                selectAll['selected'] = true
              }
              selectAll['selectedRows'] = vm.rows2
            })
            vm.onSelectAll(selectAll)
            vm.loading = false
          })
          .catch(function (error) {
            console.log(error)
            vm.loading = false
            let obj = {
              title: 'Problem looking up results for dashboard',
              message: error.response.data.message,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      postSyncDashboard: function () {
        let vm = this
        let endpoint = vm.syncDashboardUrl
        let payload = {}
        payload['name'] = vm.modalDashboardNameInput
        payload['appIds'] = vm.modalDashboardAppIds
        vm.loading = true
        vm.axios.post(endpoint, payload)
          .then(function (response) {
            vm.loading = false
            vm.getSyncDashboards()
            vm.closeModalBtnClick()
            let obj = {
              title: 'Dashboard saved',
              message: response.data,
              type: 'success'
            }
            vm.$Simplert.open(obj)
          })
          .catch(function (error) {
            console.log(error)
            vm.loading = false
            let obj = {
              title: 'Unable to save dashboard',
              message: error,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      clickCreateNew: function () {
        this.modalTitle = 'Create new dashboard'
        this.getSyncDashboardResults('all-apps')
      },
      saveModalBtnClick: function () {
        this.postSyncDashboard()
      },
      viewBtnClick: function (row) {
        this.getSyncDashboardResults(row.name)
        this.$router.push({name: 'SyncDashboard', params: {name: row.name}})
      },
      updateBtnClick: function (row) {
        this.modalTitle = 'Dashboard: ' + row.name
        this.modalDashboardNameInput = row.name
        this.getSyncDashboardResults(row.name)
      },
      deleteBtnClick: function (row) {
        this.modalTitle = 'Confirm delete on dashboard: ' + row.name
        this.modalDeleteShow = true
        this.dashboardToBeDeleted = row.name
        this.modalDashboardNameInput = ''
      },
      closeModalBtnClick: function () {
        this.modalShow = false
        this.modalDeleteShow = false
        this.modalMergeShow = false
        this.modalDashboardNameInput = ''
        this.modalDashboardAppIds = []
        this.modalDeleteConfirmInput = ''
      },
      confirmDeleteModalBtnClick: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/sync-dashboard/' + vm.dashboardToBeDeleted
        vm.loading = true
        vm.axios.delete(endpoint)
          .then(function (response) {
            // console.log(response.data)
            vm.loading = false
            vm.getSyncDashboards()
            vm.closeModalBtnClick()
            let obj = {
              title: 'Dashboard deleted',
              message: response.data,
              type: 'success'
            }
            vm.$Simplert.open(obj)
          })
          .catch(function (error) {
            console.log(error)
            vm.loading = false
            vm.closeModalBtnClick()

            let obj = {
              title: 'Unable to delete dashboard',
              message: error,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      onRowClick: function (params) {
        let index = this.modalDashboardAppIds.indexOf(params.row.id)
        let exists = index !== -1
        if (params.selected) {
          if (!exists) {
            this.modalDashboardAppIds.push(params.row.id)
          }
        } else {
          if (exists) {
            this.modalDashboardAppIds.splice(index, 1)
          }
        }
      },
      onSelectAll: function (params) {
        let vm = this
        vm.modalDashboardAppIds = []
        params.selectedRows.forEach(function (key) {
          if (params.selected) {
            vm.modalDashboardAppIds.push(key.id)
            key.vgtSelected = true
          }
        })
      },
      repickAppsModalBtnClick: function () {
        let vm = this
        this.modalDashboardAppIds = []
        vm.getSyncDashboardResults('all-apps')
      },
      formatMillis: function (value) {
        return DatetimeStringFactory.formatMillis(value)
      }
    },
    created () {
      let vm = this
      vm.getSyncDashboards()
      if (vm.$route.params.name) {
        vm.getSyncDashboardResults(vm.$route.params.name)
        vm.timer = setInterval(function () {
          console.log('Update data timer ' + new Date())
          vm.getSyncDashboardResults(vm.$route.params.name)
        }, 300000) // 5 minutes
      }
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.closeModalBtnClick()
        }
      })
    },
    beforeDestroy: function () {
      clearInterval(this.timer)
    },
    watch: {
      'modalDeleteConfirmInput': function (newValue) {
        if (newValue === 'DELETE') {
          this.deleteDisabled = false
        } else {
          this.deleteDisabled = true
        }
      },
      modalDashboardAppIds: function (newValue) {
        // console.log(newValue)
      }
    },
    computed: {
      columns: function () {
        return [
          {
            label: 'Dashboard Name',
            field: 'name'
          },
          { label: 'Actions',
            field: 'actions'
          }
        ]
      },
      columns2: function () {
        return [
          {
            label: 'Name',
            field: 'appName',
            filterable: true
          },
          {
            label: 'App ID',
            field: 'id',
            filterable: true
          }
        ]
      },
      columns3: function () {
        return [
          {
            label: 'Status',
            field: 'status'
          },
          {
            label: 'Name',
            field: 'appName',
            filterable: true
          },
          // {
          //   label: 'App ID',
          //   field: 'id',
          //   filterable: true
          // },
          {
            label: 'Helium Base Url',
            field: 'heliumBaseUrl',
            filterable: true
          },
          {
            label: 'Journey Base Url',
            field: 'journeyBaseUrl',
            filterable: true
          },
          {
            label: 'Helium Last Updated',
            field: 'heliumLastUpdated',
            filterable: true
          },
          {
            label: 'Journey Last Updated',
            field: 'journeyLastUpdated',
            filterable: true
          },
          {
            label: 'Last Pinged',
            field: 'lastPinged',
            filterable: true
          }
        ]
      },
      modalIsEditMode: function () {
        return this.modalTitle !== 'Create new dashboard'
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// SyncDashboard.vue?3c058bfa